<template>
  <div class="">
    <!-- Header and Add Button -->
    <div class="flex flex-col md:flex-row md:items-center md:justify-between mb-4 gap-4">
      <div class="flex items-center gap-2">
        <!-- material back button -->
        <button @click="goBack" class="flex items-center gap-2 bg-blue-800 hover:bg-blue-900 rounded p-1 transition text-white">
          <span class="material-icons text-base">arrow_back</span>
        </button>
        <h2 class="text-xl font-semibold text-gray-800">
          List of Music {{ all.length && all[0].god.name ? `under ${all[0].god.name} category` : "" }}
        </h2>
      </div>
      <button
        @click="addingNewItem"
        class="flex items-center gap-2 bg-blue-800 hover:bg-blue-900 text-white font-semibold px-3 py-2 rounded-lg shadow transition"
      >
        <span class="material-icons text-base">add</span>
        Add Music
      </button>
    </div>
    <!-- Filter Bar -->
    <div class="flex flex-wrap items-center justify-between gap-2 mb-4">
      <div class="flex bg-gray-200 rounded-lg">
        <!-- music category to filter -->
        <button
          class="px-4 py-2 font-medium focus:outline-none transition select-none text-gray-600 hover:bg-gray-200"
          :class="search.category === '' ? 'bg-white text-indigo-700 font-semibold shadow-md rounded-lg z-10' : ''"
          @click="
            search.category = '';
            searchData();
          "
        >
          All
        </button>
        <button
          v-for="mCat in musicCategories"
          :key="mCat.name"
          :value="mCat.value"
          :class="[
            'px-4 py-2 font-medium focus:outline-none transition select-none',
            search.category === mCat.value ? 'bg-white text-indigo-700 font-semibold shadow-md rounded-lg z-10' : 'text-gray-600 hover:bg-gray-200',
          ]"
          @click="
            search.category = mCat.value;
            searchData();
          "
        >
          {{ mCat.name }}
        </button>
      </div>
      <!--  Search and Sort Controls -->
      <div class="flex items-center gap-2">
        <vs-select v-model="search.language" @change="searchData" class="w-28" :color="'#6366f1'">
          <vs-select-item value="all" text="Language" disabled />
          <vs-select-item v-for="lang in languages" :key="lang.culture" :value="lang.culture" :text="lang.culture" />
        </vs-select>
        <vs-select v-model="search.sort" @change="searchData" class="w-28" :color="'#6366f1'">
          <vs-select-item value="ASC" text="Ascending" />
          <vs-select-item value="DESC" text="Descending" />
        </vs-select>
        <button
          @click="sortPositions()"
          class="flex items-center gap-1 bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-lg font-medium transition"
        >
          <span class="material-icons text-base">sort</span> Sort
        </button>
        <button
          @click="resetData()"
          class="flex items-center gap-1 bg-yellow-500 hover:bg-yellow-600 text-white px-4 py-2 rounded-lg font-medium transition"
        >
          <span class="material-icons text-base">refresh</span> Reset
        </button>
      </div>
    </div>
    <!-- Music List Table -->
    <div class="overflow-x-auto rounded-xl border border-gray-200 bg-white pb-2">
      <table class="min-w-full bg-white rounded-xl">
        <thead class="border-b">
          <tr>
            <th class="px-4 py-3 text-xs font-semibold text-gray-500 uppercase">#</th>
            <th class="px-4 py-3 text-xs text-start font-semibold text-gray-500 uppercase">Category Image</th>
            <th class="px-4 py-3 text-xs text-start font-semibold text-gray-500 uppercase">Feature Image</th>
            <th class="px-4 py-3 text-xs font-semibold text-gray-500 uppercase">Name</th>
            <th class="px-4 py-3 text-xs text-center font-semibold text-gray-500 uppercase cursor-pointer" @click="sortTable('position')">
              Position
              <span v-if="sortColumn === 'position'">
                {{ sortOrder === "asc" ? "▲" : "▼" }}
              </span>
            </th>
            <th class="px-4 py-3 text-xs text-center font-semibold text-gray-500 uppercase">Author</th>
            <th class="px-4 py-3 text-xs text-center font-semibold text-gray-500 uppercase">Music Category</th>
            <th class="px-4 py-3 text-xs text-center font-semibold text-gray-500 uppercase">Language</th>
            <th class="px-4 py-3 text-xs text-center font-semibold text-gray-500 uppercase cursor-pointer" @click="sortTable('plays')">
              Plays
              <span v-if="sortColumn === 'plays'">
                {{ sortOrder === "asc" ? "▲" : "▼" }}
              </span>
            </th>
            <th class="px-4 py-3"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(music, idx) in all" :key="music._id" class="border-b hover:bg-gray-100 transition">
            <!-- <td class="px-4 py-3">{{ idx + 1 + (currentPage - 1) * limit }}</td> #### no pagination yet -->
            <td class="px-4 py-1">{{ idx + 1 }}</td>
            <td class="">
              <img
                :src="music.god.image || require('@/assets/images/No-image.png')"
                class="rounded-md object-cover"
                style="width: 90px; height: 60px"
              />
            </td>
            <td class="">
              <img
                :src="music.featureImage || require('@/assets/images/No-image.png')"
                class="rounded-md object-cover"
                style="width: 90px; height: 60px"
              />
            </td>
            <td class="px-4 py-1 font-medium text-gray-800">{{ music.title }}</td>
            <td class="px-4 py-1 text-center">
              <div class="flex flex-col items-center gap-2">
                <button
                  class="flex items-center justify-center border-2 border-gray-100 rounded-md w-6 h-6 disabled:opacity-50"
                  :disabled="music.position === 1"
                  @click.stop="updatePosition(music._id, search.sort === 'ASC' ? 'up' : 'down')"
                >
                  <svg
                    :class="music.position === 1 ? 'text-gray-200' : 'text-gray-400'"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    class="w-10 h-10"
                  >
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 15l-7-7-7 7" />
                  </svg>
                </button>
                <span class="font-semibold text-gray-700">{{ music.position }}</span>
                <button
                  class="flex items-center justify-center border-2 border-gray-100 rounded-md w-6 h-6 disabled:opacity-50"
                  :disabled="music.position === all.length"
                  @click.stop="updatePosition(music._id, search.sort === 'ASC' ? 'down' : 'up')"
                >
                  <svg
                    :class="music.position === all.length ? 'text-gray-200' : 'text-gray-400'"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    class="w-10 h-10"
                  >
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                  </svg>
                </button>
              </div>
            </td>
            <td class="px-4 py-1 text-center">
              <span class="text-gray-700 font-semibold">{{ music.author }}</span>
            </td>
            <td class="px-4 py-1 text-center">
              <span class="text-gray-700 font-semibold">{{ music.god.name }}</span>
            </td>
            <td
              class="px-4 py-1 text-center"
              :title="
                music.language === 'EN' && music.missingLanguages.length > 0
                  ? `Missing: ${music.missingLanguages.join(', ')}`
                  : 'All languages available'
              "
            >
              <div class="flex items-center justify-center gap-2">
                <span class="text-gray-500 text-lg">{{ music.language }}</span>
                <span
                  v-if="music.languageCount && music.missingLanguages && music.language === 'EN'"
                  :class="[
                    'inline-flex items-center px-2 py-1 rounded-full font-semibold cursor-pointer',
                    music.languageCount - music.missingLanguages.length !== 11 ? 'bg-red-900 text-white' : 'bg-blue-900 text-white',
                  ]"
                >
                  {{ music.languageCount - music.missingLanguages.length }}/{{ music.languageCount }}
                </span>
                <span v-if="music.language === 'EN'" class="material-icons text-gray-400 cursor-pointer" style="font-size: 20px">info</span>
              </div>
            </td>
            <td class="px-4 py-1 text-center font-semibold text-gray-700">
              <!-- show recentPlays and totaLPlays (recent plays is 24h ) -->
              <div class="flex flex-col items-center">
                <span class="text-sm text-gray-500">24h</span>
                <span class="text-sm">{{ music.recentPlays || 0 }}</span>
                <span class="text-sm text-gray-500">Total</span>
                <span class="text-sm">{{ music.plays || 0 }}</span>
              </div>
            </td>
            <td class="px-4 py-1">
              <vs-dropdown>
                <svg class="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <circle cx="12" cy="5" r="1.5" />
                  <circle cx="12" cy="12" r="1.5" />
                  <circle cx="12" cy="19" r="1.5" />
                </svg>
                <vs-dropdown-menu>
                  <vs-dropdown-item @click="editMusic(music)"> <vs-icon icon="create" class="align-right" /> Edit </vs-dropdown-item>
                  <vs-dropdown-item @click="deleteMusic(music)"> <vs-icon icon="delete_sweep" /> Delete </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </td>
          </tr>
          <tr v-if="!all || all.length === 0">
            <td colspan="12" class="text-center h-full py-6 text-gray-400">No music found.</td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- Pagination ### no pagination yet -->
    <!-- <div class="flex flex-col md:flex-row items-center justify-between mt-3 pr-3">
      <div class="invisible">
        <span>asd</span>
      </div>
      <div class="flex justify-center items-center">
        <vs-pagination v-model="currentPage" :total="totalPages" :limit="1" @change="searchData" class="my-2" />
      </div>
      <div class="flex items-center gap-2 text-sm mt-2 md:mt-0">
        <span>Show Records:</span>
        <vs-select v-model="limit" @change="searchData" class="w-20" :color="'#6366f1'">
          <vs-select-item value="25" text="25" />
          <vs-select-item value="50" text="50" />
          <vs-select-item value="100" text="100" />
        </vs-select>
      </div>
    </div> -->

    <!-- Add Music Popup -->
    <vs-popup :title="isEdit ? 'Edit Music' : 'Add New Music'" :active.sync="addMusicPopup">
      <form @submit.prevent="isEdit ? handleUpdateMusic() : handleSaveMusic()">
        <!-- language filter -->
        <div class="mb-2 px-2 flex justify-between">
          <div class="w-1/4" v-if="isEdit">
            <label class="block text-sm font-semibold mb-2">Language</label>
            <vs-select
              v-model="music.language"
              @change="refetchUsingLangugage($event, music)"
              class="w-full"
              :color="'#6366f1'"
              :disabled="showLoader"
            >
              <vs-select-item value="" text="Select Language" disabled />
              <vs-select-item v-for="lang in languages" :key="lang.culture" :value="lang.culture" :text="lang.culture" />
            </vs-select>
          </div>
          <div v-if="isEdit && music.language === 'EN'" :title="'Toggle to update existing translations'">
            <!-- toggle pill to update existing translations -->
            <label class="block text-sm font-semibold mb-2">Update Translations</label>
            <toggle-pill v-model="music.translate" :disabled="showLoader" />
          </div>
        </div>
        <div class="px-2">
          <!-- title -->
          <label class="block text-sm font-semibold">Title</label>
          <vs-input v-model="music.title" placeholder="Keep short and simple" class="w-full" required :disabled="showLoader" />
          <!-- author -->
          <label class="block text-sm font-semibold">Author</label>
          <vs-input v-model="music.author" placeholder="Author of the music" class="w-full" required :disabled="showLoader" />

          <div class="mb-6 flex flex-col md:flex-row md:items-center md:gap-6">
            <div class="flex-1" style="width: 100px; height: 150px">
              <div class="flex justify-between items-start">
                <!-- image -->
                <label class="block text-sm font-semibold">Image</label>
                <button
                  v-if="displayImage"
                  type="button"
                  color="danger"
                  class="bg-red-500 p-1 h-6 rounded-md hover:bg-red-700 transition text-white"
                  @click="clearImage"
                  :disabled="showLoader"
                >
                  Clear
                </button>
              </div>
              <!-- image -->
              <div
                class="flex flex-col items-center justify-center border-2 border-dashed rounded-md cursor-pointer bg-gray-50 hover:bg-gray-100 transition"
                style="width: 100%; height: 140px; min-height: 140px"
                @dragover.prevent
                @dragenter.prevent
                @drop.prevent="onDropImage"
                @click="triggerFileInput"
              >
                <img v-if="displayImage" :src="displayImage" class="rounded-md object-cover border" style="width: 200px; max-height: 140px" />
                <div v-else class="flex flex-col items-center justify-center w-full h-full text-gray-400">
                  <span class="material-icons" style="font-size: 32px">cloud_upload</span>
                  <span>Drag & Drop or Click to Upload</span>
                </div>
                <input
                  type="file"
                  ref="fileInput"
                  class="hidden"
                  @change="onImageChange"
                  accept="image/jpeg,image/jpg,image/webp"
                  :disabled="showLoader"
                />
              </div>
            </div>
            <div class="flex flex-col gap-7">
              <!-- postion -->
              <div class="flex-1 pt-2">
                <label class="block text-sm font-semibold"
                  >Position
                  <span v-if="isEdit" class="font-bold">: {{ music.position ? music.position : "Not set" }}</span>
                </label>
                <div class="flex gap-4">
                  <vs-checkbox v-model="music.moveTop" @change="onMoveTopChange" :disabled="showLoader">Move to Top</vs-checkbox>
                  <vs-checkbox v-model="music.moveBottom" @change="onMoveBottomChange" :disabled="showLoader">Move to Bottom</vs-checkbox>
                </div>
              </div>
              <!-- music category -->
              <div class="flex-1">
                <label class="block text-sm font-semibold">Music Category</label>
                <vs-select v-model="music.category" class="w-full" :color="'#6366f1'" :disabled="showLoader">
                  <vs-select-item value="" text="Select Category" disabled />
                  <vs-select-item v-for="cat in musicCategories" :key="cat.value" :value="cat.value" :text="cat.name" />
                </vs-select>
              </div>
            </div>
          </div>

          <!-- music file -->
          <div class="pt-2">
            <label class="block text-sm font-semibold">Music File</label>
            <div class="flex items-center gap-4">
              <input type="file" ref="musicFileInput" accept="audio/*" class="hidden" :disabled="showLoader" @change="onMusicChange" />
              <button
                type="button"
                @click="triggerFileInputMusic"
                class="text-white px-4 py-2 rounded-lg font-medium transition"
                :class="displayName && music.link ? 'bg-red-500 hover:bg-red-600' : 'bg-blue-500 hover:bg-blue-600'"
                :disabled="showLoader"
              >
                {{ displayName && music.link ? "Dismiss File" : "Upload File" }}
              </button>
              <span v-if="displayName" class="text-gray-700">{{ displayName }}</span>
            </div>
          </div>

          <!-- independent language to translate -->
          <div class="pt-2" v-if="!isEdit">
            <label class="block text-sm font-semibold mb-2">Choose Languages to Translate</label>
            <div class="grid grid-cols-7 gap-2">
              <vs-checkbox v-model="selectAllLang" @change="toggleSelectAll" :disabled="showLoader" class="z-0">All</vs-checkbox>
              <div v-for="lang in languages" :key="lang.culture">
                <vs-checkbox
                  :value="music.languagesToTranslate.includes(lang.culture)"
                  @change="toggleLanguage(lang.culture)"
                  :disabled="lang.culture === 'EN' || showLoader"
                  class="z-0"
                >
                  {{ lang.culture }}
                </vs-checkbox>
              </div>
            </div>
          </div>
          <!-- add missing languages -->
          <div v-if="isEdit && music.language === 'EN' && music.missingLanguages && music.missingLanguages.length > 0">
            <label class="block text-sm font-semibold pt-1 mb-2">Add missing translations</label>
            <vs-checkbox v-model="music.translateMissing" :disabled="showLoader">Add missing translations</vs-checkbox>
            <div v-if="music.translateMissing" class="grid grid-cols-7 gap-2 mt-3">
              <vs-checkbox v-model="selectAllEdit" @change="toggleSelectAllEdit" :disabled="showLoader" class="z-0">All</vs-checkbox>
              <div v-for="lang in music.missingLanguages" :key="lang">
                <vs-checkbox
                  :value="music.languagesToTranslate.includes(lang) && lang !== 'EN'"
                  :disabled="lang === 'EN' || showLoader"
                  @change="toggleLanguage(lang)"
                  class="z-0"
                >
                  {{ lang }}
                </vs-checkbox>
              </div>
            </div>
          </div>

          <!-- loader -->
          <div v-if="showLoader" class="mb-4 text-blue-700">Translations are working in background...</div>

          <div class="flex flex-col md:flex-row gap-3 mt-8">
            <vs-button
              v-if="isEdit && !music.translateMissing"
              :loading="showLoader"
              color="primary"
              type="filled"
              class="flex-1"
              @click="handleUpdateMusic"
              :disabled="showLoader"
            >
              Update current
            </vs-button>
            <vs-button
              v-if="isEdit && music.language === 'EN'"
              :loading="showLoader"
              color="primary"
              type="filled"
              class="flex-1"
              @click="handleUpdateAllMusic"
              :disabled="showLoader"
            >
              {{ music.translateMissing ? "Update And Translate Missing" : "Update All" }}
            </vs-button>
            <vs-button
              v-if="!isEdit"
              :loading="showLoader"
              color="primary"
              type="filled"
              class="flex-1"
              @click="handleSaveMusic"
              :disabled="showLoader"
            >
              {{ music.languagesToTranslate && music.languagesToTranslate.length > 1 ? "Save and Translate" : "Save" }}
            </vs-button>
            <!-- save and translate toggle
            <div class="flex flex-col" v-if="!isEdit" style="width: 50px">
              <label class="block text-xs font-semibold">Translate?</label>
              <toggle-pill v-model="music.translate" :disabled="showLoader" />
            </div> -->
          </div>
        </div>
      </form>
    </vs-popup>
    <!-- Delete Music Confirmation Popup -->
    <vs-popup :title="'Delete Music'" :active.sync="deleteMusicPopup">
      <p class="mb-4 text-lg text-gray-700">Are you sure you want to delete this music?</p>
      <div class="flex justify-end gap-2">
        <vs-button color="warning" @click="confirmDeleteMusic">Delete</vs-button>
        <vs-button
          color="primary"
          @click="
            deleteCategoryPopup = false;
            itemToDelete = null;
          "
          >Cancel</vs-button
        >
      </div>
    </vs-popup>
  </div>
</template>

<script>
import api from "@/rest.js";
import { API } from "@/common/constants";
import TogglePill from "../components/Common/TogglePill.vue";

export default {
  name: "MusicList",
  components: {
    TogglePill,
  },
  data() {
    return {
      all: [],
      search: {
        sort: "ASC",
        language: "EN",
        category: "",
      },
      currentPage: 1,
      totalPages: 1,
      limit: 25,
      deleteMusicPopup: false,
      itemToDelete: null,
      addMusicPopup: false,
      isEdit: false,
      musicCategory: "",
      showLoader: false,
      displayImage: "",
      displayName: "",
      itemToDelete: null,
      musicCategories: [
        { name: "Bhajans", value: "bhajans" },
        { name: "Shlokas", value: "shlokas" },
        { name: "Mantras", value: "mantras" },
      ],
      music: {
        title: "",
        category: "",
        author: "",
        featureImage: "",
        god: "",
        link: "",
        language: "",
        moveBottom: false,
        moveTop: false,
        translate: false,
        translateMissing: false,
        languagesToTranslate: [],
      },
      selectAllLang: false,
      selectAllEdit: false,
      languages: [],
      sortColumn: null,
      sortOrder: "asc",
    };
  },
  methods: {
    toggleSelectAll() {
      if (this.selectAllLang) {
        this.music.languagesToTranslate = this.languages.map((lang) => lang.culture);
      } else {
        this.music.languagesToTranslate = ["EN"];
      }
    },

    toggleSelectAllEdit() {
      if (this.selectAllEdit) {
        this.music.languagesToTranslate = this.music.missingLanguages;
      } else {
        this.music.languagesToTranslate = ["EN"];
      }
    },

    toggleLanguage(culture) {
      const selectedLanguages = this.music.languagesToTranslate;

      if (selectedLanguages.includes(culture)) {
        this.music.languagesToTranslate = selectedLanguages.filter((lang) => lang !== culture);
      } else {
        this.music.languagesToTranslate = [...selectedLanguages, culture];
      }

      const allLanguagesSelected = this.languages.every((lang) => this.music.languagesToTranslate.includes(lang.culture));
      this.selectAllLang = allLanguagesSelected;
      if (this.selectAllEdit) {
        const allLanguagesSelected = this.music.missingLanguages.every((lang) => this.music.languagesToTranslate.includes(lang));
        this.selectAllEdit = allLanguagesSelected;
      }
    },

    goBack() {
      this.$router.push("/musicCategory");
    },

    resetData() {
      this.search = { sort: "ASC", language: "EN", category: "" };
      this.limit = 25;
      this.searchData();
    },

    onMoveTopChange() {
      if (this.music.moveTop) {
        this.music.moveBottom = false;
      } else if (!this.music.moveBottom) {
        this.music.moveBottom = true;
      }
    },

    onMoveBottomChange() {
      if (this.music.moveBottom) {
        this.music.moveTop = false;
      } else if (!this.music.moveTop) {
        this.music.moveBottom = true;
      }
    },

    editMusic(music) {
      this.clearImage();
      this.dismissMusicFile();
      this.isEdit = true;
      this.addMusicPopup = true;
      this.music = {
        ...music,
        translate: false,
        translateMissing: false,
        languagesToTranslate: ["EN"],
      };
      this.displayImage = music.featureImage || "";
      this.displayName = music.link || "";
    },

    addingNewItem() {
      this.clearImage();
      this.dismissMusicFile();
      this.isEdit = false;
      this.addMusicPopup = true;
      this.music = {
        title: "",
        category: "",
        author: "",
        featureImage: "",
        god: this.$route.params.catGuid,
        link: "",
        language: "EN",
        moveBottom: true,
        moveTop: false,
        translate: false,
        languagesToTranslate: ["EN"],
      };
      this.selectAllLang = false;
      this.selectAllEdit = false;
      if (this.$route.query.fromSelection === "true") {
        const queryParams = { ...this.$route.query };
        delete queryParams.fromSelection;
        this.$router.replace({ query: queryParams });
      }
    },

    onImageChange(event) {
      const file = event.target.files[0];
      if (file) {
        this.music.featureImage = file;
        this.displayImage = URL.createObjectURL(file);
      }
    },

    onMusicChange(event) {
      const file = event.target.files[0];
      if (file) {
        this.music.link = file;
        this.displayName = file.name;
      }
    },

    triggerFileInput() {
      if (this.$refs.fileInput) this.$refs.fileInput.click();
    },

    triggerFileInputMusic() {
      if (this.music.link) {
        this.dismissMusicFile();
        return;
      }

      if (this.$refs.musicFileInput) this.$refs.musicFileInput.click();
    },

    onDropImage(e) {
      const files = e.dataTransfer.files;
      if (files && files[0]) {
        this.onImageChange({ target: { files } });
      }
    },

    clearImage() {
      this.music.featureImage = "";
      this.displayImage = "";
      if (this.$refs.fileInput) this.$refs.fileInput.value = null;
    },

    dismissMusicFile() {
      this.music.link = "";
      this.displayName = "";
      if (this.$refs.musicFileInput) this.$refs.musicFileInput.value = null;
    },

    deleteMusic(music) {
      this.itemToDelete = music;
      this.deleteMusicPopup = true;
    },

    async confirmDeleteMusic() {
      this.$vs.loading();
      try {
        const response = await api.delete(`${API.DELETE_MUSIC}/${this.itemToDelete._id}`);
        if (response.status === 200) {
          this.$vs.notify({
            text: "Music deleted successfully",
            color: "success",
            position: "top-right",
          });
          this.deleteMusicPopup = false;
          this.itemToDelete = null;
          await this.searchData();
        }
      } catch (error) {
        this.$vs.notify({
          text: error,
          color: "danger",
          position: "top-right",
        });
      } finally {
        this.$vs.loading.close();
      }
    },

    async updatePosition(id, direction) {
      const godId = this.$route.params.catGuid;

      this.$vs.loading();
      try {
        const response = await api.put(`${API.MUSIC_UPDATE_POSITION}/${id}?direction=${direction}&god=${godId}`, {});

        if (response.status === 200) {
          this.$vs.notify({
            text: "Position updated successfully",
            color: "success",
            position: "top-right",
          });
          await this.searchData();
        }
      } catch (error) {
        this.$vs.notify({
          text: error,
          color: "danger",
          position: "top-right",
        });
      } finally {
        this.$vs.loading.close();
      }
    },

    async sortPositions() {
      const godId = this.$route.params.catGuid;

      this.$vs.loading();
      try {
        const response = await api.put(`${API.MUSIC_SORT_POSITION}?language=${this.$data.search.language}&god=${godId}`, {});
        if (response.status === 200) {
          this.$vs.notify({
            text: "Sorted Successfully",
            color: "success",
            position: "top-right",
          });
          await this.searchData();
        }
      } catch (error) {
        this.$vs.notify({
          text: error,
          color: "danger",
          position: "top-right",
        });
      } finally {
        this.$vs.loading.close();
      }
    },

    async searchData() {
      this.$vs.loading();
      try {
        const r = await api.get(
          `${API.SEARCH_MUSIC}?sort=${this.$data.search.sort}&language=${this.$data.search.language}&category=${this.$data.search.category}&god=${this.$route.params.catGuid}`
        );
        if (r.status === 200) {
          this.$data.all = r.data;
        }
      } catch (error) {
        this.$vs.notify({
          text: "Error fetching music list",
          color: "danger",
          position: "top-right",
        });
      } finally {
        this.$vs.loading.close();
      }
    },

    async handleUploadImage(file) {
      if (!file || !(file instanceof File)) {
        return null;
      }

      let imageUrl = "";
      let formData = new FormData();
      formData.append("file", file);

      try {
        const response = await api.post(API.UPLOAD_IMAGE, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        if (response.data) {
          imageUrl = response.data.files[0].url;
        }
      } catch (e) {
        this.$vs.loading.close();
        this.$vs.notify({
          text: "File Uploading Failed",
          color: "danger",
          position: "top-right",
        });
        return console.log(e);
      } finally {
        this.$vs.loading.close();
      }
      return imageUrl;
    },

    async uploadMusic(file) {
      this.$vs.loading();

      if (!file || !(file instanceof File)) {
        return null;
      }

      try {
        const allowedTypes = [
          "audio/mpeg",
          "audio/x-m4a",
          "audio/x-ms-wma",
          "audio/wav",
          "audio/vnd.dlna.adts",
          "audio/aac",
          "audio/ogg",
          "audio/mp3",
          "audio/flac",
        ];
        if (!allowedTypes.includes(file.type)) {
          this.$vs.notify({
            title: "Uploading Error",
            text: "Only music file formats are supported",
            color: "danger",
            position: "top-right",
          });
          return;
        }

        let formdata = new FormData();
        this.fileName = file.name;
        formdata.append("file", file);
        formdata.append("god", this.$route.params.catGuid);
        formdata.append("category", this.music.category || "none");

        const response = await api.post(API.UPLOAD_MUSIC, formdata, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        if (response.data && response.data.files && response.data.files[0]) {
          const rawUrl = response.data.files[0].url;
          this.music.link = rawUrl.replace(/\\/g, "/");
          this.displayName = this.music.link;
          return this.music.link;
        }
      } catch (error) {
        this.$vs.notify({
          text: error,
          color: "danger",
          position: "top-right",
        });
      } finally {
        this.$vs.loading.close();
      }
    },

    async handleUpdateAllMusic() {
      if (!this.music.title || !this.music.god || !this.music.featureImage || !this.music.author || !this.music.link || !this.music.category) {
        this.$vs.notify({
          text: "Please fill in all required fields",
          color: "warning",
          position: "top-right",
        });
        return;
      }
      this.$vs.loading();

      let imgUrl;
      let audioUrl;

      if (this.music.featureImage instanceof File || this.music.link instanceof File) {
        [audioUrl, imgUrl] = await Promise.all([this.uploadMusic(this.music.link), this.handleUploadImage(this.music.featureImage)]);
      } else {
        audioUrl = this.music.link;
        imgUrl = this.music.featureImage;
      }

      this.music.featureImage = imgUrl;
      this.music.link = audioUrl;

      const data = {
        ...this.music,
      };

      this.showLoader = this.music.translate;
      try {
        const r = await api.put(`${API.U_AND_T_MUSIC}/${this.music._id}`, data);

        if (r.status === 200) {
          this.$vs.notify({
            text: "Music updated successfully",
            color: "success",
            position: "top-right",
          });
          this.addMusicPopup = false;
          this.isEdit = false;
          await this.searchData();
        }
      } catch (error) {
        this.$vs.notify({
          text: error,
          color: "danger",
          position: "top-right",
        });
      } finally {
        this.showLoader = false;
        this.$vs.loading.close();
      }
    },

    async handleUpdateMusic() {
      if (!this.music.title || !this.music.god || !this.music.featureImage || !this.music.author || !this.music.link || !this.music.category) {
        this.$vs.notify({
          text: "Please fill in all required fields",
          color: "warning",
          position: "top-right",
        });
        return;
      }
      this.$vs.loading();

      let imgUrl;
      let audioUrl;

      if (this.music.featureImage instanceof File || this.music.link instanceof File) {
        [audioUrl, imgUrl] = await Promise.all([this.uploadMusic(this.music.link), this.handleUploadImage(this.music.featureImage)]);
      } else {
        audioUrl = this.music.link;
        imgUrl = this.music.featureImage;
      }

      this.music.featureImage = imgUrl;
      this.music.link = audioUrl;

      const data = {
        ...this.music,
      };

      this.showLoader = this.music.translate;
      try {
        const response = await api.put(`${API.UPDATE_MUSIC}/?id=${this.music._id}`, data);

        if (response.status === 200) {
          this.$vs.notify({
            text: "Music updated successfully",
            color: "success",
            position: "top-right",
          });
          this.addMusicPopup = false;
          await this.searchData();
        }
      } catch (error) {
        this.$vs.notify({
          text: "Error updating music",
          color: "danger",
          position: "top-right",
        });
      } finally {
        this.showLoader = false;
        this.$vs.loading.close();
      }
    },

    async handleSaveMusic() {
      if (!this.music.title || !this.music.god || !this.music.featureImage || !this.music.author || !this.music.link || !this.music.category) {
        this.$vs.notify({
          text: "Please fill in all required fields",
          color: "warning",
          position: "top-right",
        });
        return;
      }
      this.$vs.loading();

      let imgUrl;
      let audioUrl;

      if (this.music.featureImage instanceof File || this.music.link instanceof File) {
        [audioUrl, imgUrl] = await Promise.all([this.uploadMusic(this.music.link), this.handleUploadImage(this.music.featureImage)]);
      }

      this.music.featureImage = imgUrl;
      this.music.link = audioUrl;

      const data = {
        ...this.music,
      };

      this.showLoader = this.music.translate || (this.music.languagesToTranslate && this.music.languagesToTranslate.length > 1);
      try {
        let response;
        if (this.music.languagesToTranslate && this.music.languagesToTranslate.length > 1) {
          response = await api.post(API.C_AND_T_MUSIC, data);
        } else {
          response = await api.post(API.INSERT_MUSIC, data);
        }

        if (response.status === 200) {
          this.$vs.notify({
            text: "Music saved successfully",
            color: "success",
            position: "top-right",
          });
          this.addMusicPopup = false;
          await this.searchData();
        }
      } catch (error) {
        this.$vs.notify({
          text: "Error saving music",
          color: "danger",
          position: "top-right",
        });
      } finally {
        this.showLoader = false;
        this.$vs.loading.close();
      }
    },

    async refetchUsingLangugage(lang, music) {
      let id = music.ref || music._id;
      this.$vs.loading();

      try {
        const response = await api.get(`${API.GET_SINGLE_MUSIC}/${id}?language=${lang}`);

        if (response.status === 200) {
          this.music = Object.assign({}, response.data);
          this.displayImage = response.data.image;
        }
      } catch (error) {
      } finally {
        this.$vs.loading.close();
      }
    },

    async fetchAllLanguages() {
      this.$vs.loading();
      try {
        const r = await api.get(API.GET_LANG, {});
        this.languages = r.data;
      } catch (error) {
        this.$vs.notify({
          text: "Error fetching languages",
          color: "danger",
          position: "top-right",
        });
      } finally {
        this.$vs.loading.close();
      }
    },

    sortTable(column) {
      if (this.sortColumn === column) {
        this.sortOrder = this.sortOrder === "asc" ? "desc" : "asc";
      } else {
        this.sortColumn = column;
        this.sortOrder = "asc";
      }

      this.all.sort((a, b) => {
        let valA = a[column];
        let valB = b[column];

        if (valA == null) valA = 0;
        if (valB == null) valB = 0;

        if (this.sortOrder === "asc") {
          return valA > valB ? 1 : valA < valB ? -1 : 0;
        } else {
          return valA < valB ? 1 : valA > valB ? -1 : 0;
        }
      });
    },
  },
  async mounted() {
    this.$data.search.language = this.$route.query.catLang || "EN";
    await Promise.all([this.searchData(), this.fetchAllLanguages()]);
    if (this.$route.query.fromSelection === "true") this.addingNewItem();
  },
};
</script>

<style scoped>
.material-icons {
  font-family: "Material Icons";
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 1;
  letter-spacing: normal;
  text-transform: none;
  display: inline-block;
  white-space: nowrap;
  direction: ltr;
  -webkit-font-smoothing: antialiased;
}
</style>
